export default __webpack_public_path__ + "static/media/phonetics_puzzle.8d15427f.png";